import { render, staticRenderFns } from "./OtsMortgageRefinance.vue?vue&type=template&id=6aee6e10&scoped=true"
import script from "./OtsMortgageRefinance.vue?vue&type=script&lang=js"
export * from "./OtsMortgageRefinance.vue?vue&type=script&lang=js"
import style0 from "./OtsMortgageRefinance.vue?vue&type=style&index=0&id=6aee6e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aee6e10",
  null
  
)

export default component.exports